import React, { useCallback, useEffect, useState } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Button } from 'crux';
import { withTheme } from 'styled-components';
import LocalStorageServices from '../../util/localStorageServices';
import { HeaderWrapper, Links, Logo, ButtonWrapper,  HeaderText, PhoneNumber } from './styles';
import CustomHeader from './CustomHeader';
import { removeAuthHeaders } from '../../redux/actions/authHandler';
import { isIe } from '../../utils';

const Header = (props) => {
  const {
    layout,
    background,
    isSmallScreen,
    loading,
    handleLogout,
    height,
    customHeader: { isPresent, ...customHeader } = {},
    agentParams,
    role,
  } = props;
  const [fade, setFade] = useState(false);
  const telePhone = agentParams ? agentParams.agentPhone : null;
  const scrollListener = useCallback(() => {
    if (isSmallScreen) {
      return;
    }
    if (window.scrollY > 50) {
      setFade(true);
    } else {
      setFade(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', scrollListener);
    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const branding = get(props, 'theme.config.branding', {});
  const hasLoginEnabled = get(props, 'theme.config.features.login.enable', false);
  const hasLogoutButton = hasLoginEnabled && !loading && LocalStorageServices.getAccessToken();
  const headerText = `${agentParams.agentName} ${telePhone ? `| ` : ``}`;
  return (
    <>
      {isPresent ? (
        <CustomHeader
          bannerStyles={ { ...customHeader.banner } }
          background={ background }
          branding={ branding }
          layout={ layout }
        />
      ) : (
        <>
          <HeaderWrapper
            name="header-wrapper"
            isSmallScreen={ isSmallScreen }
            background={ background }
            layout={ layout }
            fade={ fade }
            isIe={ isIe() }
            height= { height }
          >
            <Logo isSmallScreen={ isSmallScreen }>
              <a href={ branding.link } target="_blank" rel="noopener noreferrer">
                <img
                  src={ layout === 'double' ? branding.darkLogo : branding.lightLogo }
                  alt={ branding.altText }
                />
              </a>
            </Logo>
            <Links />
           <HeaderText>
              { role && role.toLowerCase() === 'client' ? 
                <p className="fs-mask">
                  My Agent: <strong>{headerText}</strong> {telePhone && <PhoneNumber href={ `tel: ${telePhone}`}>{telePhone}</PhoneNumber>}
                </p> : ''
              }
           </HeaderText>
          </HeaderWrapper>
          { hasLogoutButton && (
            <ButtonWrapper>
              <Button
                shape="rectangle"
                label="Logout"
                type="outline"
                color="blue"
                alignment="center"
                handleButtonClick={ handleLogout }
              />
            </ButtonWrapper>
          )}
        </>
      )}
    </>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    handleLogout: () => {
      dispatch(removeAuthHeaders());
    },
  };
}

export default connect(null, mapDispatchToProps)(withTheme(Header));
